import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../commanstyles.module.css";
import DirectorsComments from "./DirectorsComments";
import GST from "./GST";
import LegalHistory from "./LegalHistory";
import Establishment from "./Establishment";
import Compliance from "./Compliance";
import CreditRatings from "./CreditRatings";
import { getcompliancecheck } from "../../../Services/APIrequests";
import StatutaryComments from "./StatutaryComments";
import SecretarialComments from "./SecretarialComments";
import CostAuditorComments from "./CostAuditorComments";

function ComplianceCheck({ isSubScribe, refreshLoading, Companyname }) {
  const { cin } = useParams();

  const financialData = [
    // { title: "Director Comments" },
    { title: "Statutary Auditors Comments" },
    { title: "Secretarial Auditors Comments" },
    { title: "Cost Auditor Comments" },
    { title: "GST" },
    { title: "Legal History" },
    // { title: "Credit Ratings" },
    { title: "EPFO" },

  ];

  const [activeTab, setActiveTab] = useState(financialData[0].title);
  const [complianceCheck, setcomplianceCheck] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getcompliancecheck(cin);
        const data = response?.data || {};
        setcomplianceCheck(data);
      } catch (error) {
        console.error("Error fetching compliance data:", error);
      }
    };
    if (refreshLoading == false) {

      fetchData();
    }
  }, [cin], refreshLoading);

  const renderTableContent = () => {
    switch (activeTab) {
      case "Director Comments":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>Director Comments</h1>
            <DirectorsComments
              data={complianceCheck.auditorsComment}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      case "Statutary Auditors Comments":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>Statutary Auditors Comments</h1>
            <StatutaryComments
              data={complianceCheck.statutaryComment}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      case "Secretarial Auditors Comments":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>Secretarial Auditors Comments</h1>
            <SecretarialComments
              data={complianceCheck.secretarialComment}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      case "GST":
        return (
          <div>
            {/* <h1 className={styles.Compilance_header_text}>GST</h1> */}
            <GST data={complianceCheck.gst} isSubScribe={isSubScribe} />
          </div>
        );
      case "Legal History":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>Legal History</h1>
            <LegalHistory
              Companyname={Companyname}
              data={complianceCheck.legalHistory}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      case "Cost Auditor Comments":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>Cost Auditor Comments</h1>
            <CostAuditorComments
              data={complianceCheck.costAuditorComment}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      // case "Credit Ratings":
      //   return (
      //     <div>
      //        <h1 className={styles.Compilance_header_text}>Credit Ratings</h1>
      //       <CreditRatings
      //         data={complianceCheck.creditRatings}
      //         isSubScribe={isSubScribe}
      //       />
      //     </div>
      //   );
      case "EPFO":
        return (
          <div>
            <h1 className={styles.Compilance_header_text}>EPFO</h1>
            <Establishment
              data={complianceCheck.establishment}
              isSubScribe={isSubScribe}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.structure_container}>
      <div className={styles.Compilance_container}>
        <div className={styles.finace_subcontainer}>
          <div className={styles.finac_box}>
            {financialData.map((item, index) => (
              <div
                key={index}
                className={`${styles.finac_box_text_container} ${activeTab === item.title ? styles.Active_subTab : ""
                  }`}
                onClick={() => setActiveTab(item.title)}
              >
                <h4 className={styles.finac_box_header}>{item.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
      {renderTableContent()}
    </div>
  );
}

export default ComplianceCheck;
